import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SanitizeService } from 'src/app/services/sanitize.service';

@Component({
  selector: 'app-section-banner',
  templateUrl: './section-banner.component.html',
  styleUrls: ['./section-banner.component.scss']
})
export class SectionBannerComponent implements OnInit {
  @Input() data;

  constructor(private translate: TranslateService, public sanitizeService: SanitizeService) {}

  ngOnInit() {}
}
